import { render, staticRenderFns } from "./PointSection.vue?vue&type=template&id=2890c5c4&scoped=true&"
import script from "./PointSection.vue?vue&type=script&lang=js&"
export * from "./PointSection.vue?vue&type=script&lang=js&"
import style0 from "./PointSection.vue?vue&type=style&index=0&id=2890c5c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2890c5c4",
  null
  
)

export default component.exports